"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M17.843 28.686a3.024 3.024 0 0 1 .3-.686H16V8h8v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8h8v20H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h7.722zm17.895-6.922l-3.506-3.506a.739.739 0 0 0-.527-.215h-.023a.834.834 0 0 0-.564.247L20.3 29.113a.607.607 0 0 0-.153.256l-2.027 6c-.069.229.279.517.476.517a.3.3 0 0 0 .037 0c.168-.039 5.123-1.764 6-2.028a.6.6 0 0 0 .252-.151l10.821-10.829a.836.836 0 0 0 .246-.537.743.743 0 0 0-.214-.577zm-11.6 10.963c-1.314.395-3.3 1.23-4.43 1.568l1.56-4.432z" })
);

